import { StaticProvider } from '@angular/core';
import { FeatureServiceDef, provideFeature } from '@y42/feature';
import { Y42GitFolders } from '@y42/feature/git';
import { Y42Routes } from '@y42/feature/routing';
import { Y42FeatureType } from '@y42/json-schema';
import { CatalogAclService } from './state/catalog/catalog-acl.service';
import { CatalogGitService } from './state/catalog/catalog-git.service';
import { CatalogQuery } from './state/catalog/catalog.query';
import { CatalogService } from './state/catalog/catalog.service';
import { CatalogStore } from './state/catalog/catalog.store';

const CatalogFeatureProviders: () => FeatureServiceDef = () => {
  return {
    FEATURE_TYPE: Y42FeatureType.Catalog,
    FEATURE_ROUTE: Y42Routes.Catalog,
    GIT_FOLDER: Y42GitFolders.Catalog,
    DETAIL_TABS: [],
    AbstractFeatureService: CatalogService,
    AbstractFeatureQueryEntity: CatalogQuery,
    AbstractFeatureEntityStore: CatalogStore,
    AbstractFeatureGitService: CatalogGitService,
    AbstractFeatureAclService: CatalogAclService,
    AbstractFeatureChildQueryEntity: null,
  };
};

export function CatalogProviders(): StaticProvider[] {
  return provideFeature(CatalogFeatureProviders());
}
